import React from 'react';
import { LegalLayout, Article, Bullets } from '../components/ui/LegalLayout';

/**
 * プライバシーポリシー。
 * 記載内容は実装（myoaku-website/api/app.py）が実際に行っている処理と
 * 一致させること。取得項目を増やしたら必ずここも更新する。
 */
const PrivacyPage: React.FC = () => (
  <LegalLayout
    eyebrow="Privacy Policy"
    title="プライバシーポリシー"
    updatedAt="2026年8月30日"
    lead="オーアーク株式会社（以下「当社」）は、お客様の個人情報の保護を重要な責務と認識し、個人情報の保護に関する法律その他の関係法令を遵守し、以下のとおり取り扱います。"
  >
    <Article title="第1条（事業者情報）">
      <ul className="space-y-2">
        <li>事業者名：オーアーク株式会社（MYOAKU Co., Ltd.）</li>
        <li>代表者：代表取締役 徐 科（XU KE）</li>
        <li>所在地：〒132-0013 東京都江戸川区江戸川2丁目30-6 小倉荘201号室</li>
        <li>
          連絡先：
          <a href="/monitor.html#form-head" className="text-brand-600 underline underline-offset-4">お申し込みフォーム</a>の「ご質問・ご要望」欄よりお問い合わせください
        </li>
      </ul>
    </Article>

    <Article title="第2条（取得する個人情報）">
      <p>当社は、本サイトの申し込みフォームを通じて以下の情報を取得します。</p>
      <p className="font-bold text-ink-900">1. お客様にご入力いただく情報</p>
      <Bullets
        items={[
          '会社名',
          'ご担当者名',
          'メールアドレス',
          '電話番号',
          '会社規模',
          '現在ご利用の会計ソフト（任意項目）',
          'ご質問・ご要望の内容（任意項目）',
        ]}
      />
      <p className="font-bold text-ink-900">2. 送信時に自動的に記録される情報</p>
      <Bullets
        items={[
          'IPアドレス',
          'ご利用のブラウザおよびOSの情報（ユーザーエージェント）',
          '送信日時',
        ]}
      />
      <p className="text-small">
        自動的に記録される情報は、不正な大量送信やいたずら投稿を防止する目的でのみ使用し、
        お客様を特定するための分析には利用いたしません。
      </p>
    </Article>

    <Article title="第3条（利用目的）">
      <p>取得した個人情報は、以下の目的の範囲内でのみ利用します。</p>
      <Bullets
        items={[
          '30日間無料体験のお申し込み受付および受付確認のご連絡',
          '無料体験のご利用にあたってのご案内、セットアップ支援、サポート対応',
          'お問い合わせへの回答',
          '当社製品（サクミエ会計）の改善のための参考',
          '法令に基づく対応',
        ]}
      />
      <p>
        上記の目的を超えて利用する必要が生じた場合は、
        あらかじめお客様の同意をいただいたうえで利用いたします。
        お客様の同意なく広告・宣伝目的のメールをお送りすることはありません。
      </p>
    </Article>

    <Article title="第4条（第三者への提供）">
      <p>
        当社は、次のいずれかに該当する場合を除き、
        お客様の個人情報を第三者に提供または販売することはありません。
      </p>
      <Bullets
        items={[
          'お客様ご本人の同意がある場合',
          '法令に基づく場合',
          '人の生命、身体または財産の保護のために必要があり、お客様の同意を得ることが困難である場合',
          '国の機関等の法令の定める事務の遂行に協力する必要がある場合',
        ]}
      />
    </Article>

    <Article title="第5条（外部サービスの利用）">
      <p>
        当社は、お申し込み確認メールの送信のため、Google LLC が提供するメール送信サービス
        （Gmail／Google Workspace）を利用しています。
        このため、確認メールに記載される情報は同社のサーバーを経由します。
      </p>
      <p>
        なお、お客様の会計データそのものは本サイトでは一切お預かりしません。
        製品「サクミエ会計」は、お客様のパソコン内でのみ動作し、
        会計データが当社を含む外部に送信されることはありません。
      </p>
    </Article>

    <Article title="第6条（Cookie・アクセス解析について）">
      <p>
        本サイトでは、行動追跡を目的とした Cookie およびアクセス解析ツール
        （Google Analytics 等）を使用していません。
        広告配信事業者への情報提供も行っていません。
      </p>
      <p>
        今後これらを導入する場合は、本ポリシーを改定し、本サイト上でお知らせいたします。
      </p>
    </Article>

    <Article title="第7条（安全管理措置）">
      <p>当社は、個人情報の漏洩・滅失・毀損を防止するため、以下の措置を講じています。</p>
      <Bullets
        items={[
          '本サイトの全通信をTLSにより暗号化しています',
          '個人情報は当社が管理するサーバー内に保管し、アクセスできる者を業務上必要な範囲に限定しています',
          '管理用機能にはアクセス制限を設けています',
          '取得した情報を業務上の必要なく複製・持ち出すことを禁止しています',
        ]}
      />
    </Article>

    <Article title="第8条（保存期間）">
      <p>
        取得した個人情報は、利用目的の達成に必要な期間に限り保管します。
        お申し込みに関する情報は、
        お申し込みから3年間を目安に保管し、その後は適切な方法で削除いたします。
      </p>
      <p>
        お客様からの削除のご請求があった場合は、
        法令上保存が義務付けられている場合を除き、速やかに削除いたします。
      </p>
    </Article>

    <Article title="第9条（開示・訂正・利用停止等のご請求）">
      <p>
        お客様は、当社が保有するご自身の個人情報について、
        開示・訂正・追加・削除・利用停止・第三者提供の停止をご請求いただけます。
      </p>
      <p>
        ご請求は第11条のお問い合わせ窓口までご連絡ください。
        ご本人であることを確認させていただいたうえで、合理的な期間内に対応いたします。
        手数料はいただきません。
      </p>
    </Article>

    <Article title="第10条（本ポリシーの改定）">
      <p>
        当社は、法令の変更やサービス内容の変更に応じて、本ポリシーを改定することがあります。
        重要な変更を行う場合は、本サイト上でお知らせいたします。
        改定後の内容は、本ページに掲載した時点から効力を生じるものとします。
      </p>
    </Article>

    <Article title="第11条（お問い合わせ窓口）">
      <p>
        本ポリシーに関するご質問、個人情報の取り扱いに関するお問い合わせ、
        開示等のご請求は、以下までご連絡ください。
      </p>
      <div className="card card-pad !bg-surface-muted">
        <p className="font-bold text-ink-900">オーアーク株式会社　個人情報お問い合わせ窓口</p>
        <p className="mt-3 text-small">
          〒132-0013 東京都江戸川区江戸川2丁目30-6 小倉荘201号室
          <br />
          お問い合わせ：
          <a href="/monitor.html#form-head" className="text-brand-600 underline underline-offset-4">お申し込みフォーム</a>の「ご質問・ご要望」欄よりお送りください
        </p>
      </div>
    </Article>
  </LegalLayout>
);

export default PrivacyPage;
